function shadeColor(hex: string, percent: number): string {
  // Remove "#" if present
  hex = hex.replace(/^#/, "");

  // Parse r, g, b values
  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  // Calculate new RGB values
  r = Math.min(255, Math.max(0, r + (r * percent) / 100));
  g = Math.min(255, Math.max(0, g + (g * percent) / 100));
  b = Math.min(255, Math.max(0, b + (b * percent) / 100));

  // Convert back to hex and return
  const newHex =
    "#" +
    [r, g, b].map((x) => Math.round(x).toString(16).padStart(2, "0")).join("");

  return newHex;
}

export function getLighterAndDarker(hex: string, percent: number = 20) {
  const lighter = shadeColor(hex, percent);
  const darker = shadeColor(hex, -percent);
  return { lighter, darker };
}
